import React, { Component } from "react";
import InputRow from "./InputRow";
import Loading from "./Loading";
import PropTypes from "prop-types";
import { handleAlphabetCheck, arabicValue } from "../constants";
export default class PersonalInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fName: this.props.fName,
      mName: this.props.mName,
      lName: this.props.lName,
      dateOfBirth: "",
      selectedGender: this.props.gender || "",
      error: "",
      errorBackend: "",
      loading: true,
      dobError: "",
    };
  }

  componentDidMount() {
    this.setState({
      prefix: this.props.prefix || "",
      loading: false,
    });
    let dateOfBirth = "";
    if (this.props.dateOfBirth) {
      const date = new Date(this.props.dateOfBirth);
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let year = date.getFullYear();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      if (year < 10) year = "000" + year;
      else if (year < 100) year = "00" + year;
      else if (year < 1000) year = "0" + year;
      dateOfBirth = `${year}-${month}-${day}`;
    }
    this.setState({ dateOfBirth });

    // if (this.props.arabicData.length) {
    //   this.setState({
    //     arabicText1:
    //       this.props.arabicData.length > 0
    //         ? this.props.arabicData[0].ColumnValue
    //         : "",
    //     arabicText2:
    //       this.props.arabicData.length > 1
    //         ? this.props.arabicData[1].ColumnValue
    //         : "",
    //     arabicText3:
    //       this.props.arabicData.length > 2
    //         ? this.props.arabicData[2].ColumnValue
    //         : "",
    //   });
    // }
    // this.setState({ loading: false });
    // fetch(`${process.env.REACT_APP_API_URL}/api/PersonalInfo/GetLanguageLists`)
    //   .then((res) => res.json())
    //   .then((res) => {
    //     this.setState({
    //       selectedCountry: this.props.countryOfBirth || "",
    //       selectedNationality: this.props.nationality || "",
    //     });
    //     if (this.props.arabicData.length) {
    //       this.setState({
    //         arabicText1:
    //           this.props.arabicData.length > 0
    //             ? this.props.arabicData[0].ColumnValue
    //             : "",
    //         arabicText2:
    //           this.props.arabicData.length > 1
    //             ? this.props.arabicData[1].ColumnValue
    //             : "",
    //         arabicText3:
    //           this.props.arabicData.length > 2
    //             ? this.props.arabicData[2].ColumnValue
    //             : "",
    //       });
    //     }
    //   })
    //   .then(() =>
    //     fetch(
    //       `${process.env.REACT_APP_API_URL}/api/parentinformation/getprefixes`
    //     )
    //   )
    //   .then((res) => res.json())
    //   .then((res) => {
    //     this.setState({ prefixData: res, loading: false });
    //     if (res.length) {
    //       this.setState({ prefix: this.props.prefix || "" });
    //     }
    //     // let dateOfBirth = "";
    //     // if (this.props.dateOfBirth) {
    //     //   const date = new Date(this.props.dateOfBirth);
    //     //   let month = date.getMonth() + 1;
    //     //   let day = date.getDate();
    //     //   let year = date.getFullYear();
    //     //   if (month < 10) {
    //     //     month = "0" + month;
    //     //   }
    //     //   if (day < 10) {
    //     //     day = "0" + day;
    //     //   }
    //     //   if (year < 10) {
    //     //     year = "000" + year;
    //     //   } else if (year < 100) {
    //     //     year = "00" + year;
    //     //   } else if (year < 1000) {
    //     //     year = "0" + year;
    //     //   }
    //     //   dateOfBirth = year + "-" + month + "-" + day;
    //     // }
    //     // this.setState({ dateOfBirth: dateOfBirth });
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     this.setState({ loading: false });
    //   });
  }

  render() {
    const validationError = this.props.error;
    const {
      loading,
      error,
      dobError,
      errorBackend,
      fName,
      mName,
      lName,
      dateOfBirth,
      selectedGender,
    } = this.state;
    if (loading) {
      return <Loading />;
    }
    return (
      <div>
        <div>
          <p>
            Enter your Personal Information. When ready, click Next to navigate
            to the next section.
          </p>
          {error && <p style={{ color: "red" }}>{error}</p>}
          {errorBackend && <p>{errorBackend}</p>}
          <div>
            <InputRow
              rowName="First Name"
              name="text"
              required="*"
              errMsg={validationError.fName ? validationError.fName : ""}
              value={fName}
              hover="Insert your First Name as it appears in your Official Documents"
              onChange={(val) => {
                if (handleAlphabetCheck(val) === 1 || val === "") {
                  this.setState({ fName: val });
                  this.props.collectState("PI", {
                    fName: val,
                    mName: mName,
                    lName: lName,
                    selectedGender: selectedGender,
                    dateOfBirth: dateOfBirth,
                  });
                } else {
                  alert("Enter letters only!");
                }
              }}
            />
            <InputRow
              rowName="Middle Name"
              value={mName}
              name="text"
              required="*"
              errMsg={validationError.mName ? validationError.mName : ""}
              hover="Insert your Middle Name as it appears in your Official Documents. This is not your Father's Name. If you don't have a middle name, leave it empty"
              onChange={(val) => {
                if (handleAlphabetCheck(val) === 1 || val === "") {
                  this.setState({ mName: val });
                  this.props.collectState("PI", {
                    fName: fName,
                    mName: val,
                    lName: lName,
                    selectedGender: selectedGender,
                    dateOfBirth: dateOfBirth,
                  });
                } else {
                  alert("Enter letters only!");
                }
              }}
            />
            <InputRow
              rowName="Last Name"
              name="text"
              value={lName}
              required="*"
              errMsg={validationError.lName ? validationError.lName : ""}
              onChange={(val) => {
                if (handleAlphabetCheck(val) === 1 || val === "") {
                  this.setState({ lName: val });
                  this.props.collectState("PI", {
                    fName: fName,
                    mName: mName,
                    lName: val,
                    selectedGender: selectedGender,
                    dateOfBirth: dateOfBirth,
                  });
                } else {
                  alert("Enter letters only!");
                }
              }}
            />
            <InputRow
              rowName="Gender"
              name="select"
              value={selectedGender}
              data={[
                { Id: "Female", value: "Female" },
                { Id: "Male", value: "Male" },
              ]}
              required="*"
              errMsg={
                validationError.selectedGender
                  ? validationError.selectedGender
                  : ""
              }
              onChange={(val) => {
                this.setState({ selectedGender: val });
                this.props.collectState("PI", {
                  fName: fName,
                  mName: mName,
                  lName: lName,
                  selectedGender: val,
                  dateOfBirth: dateOfBirth,
                });
              }}
            />

            <InputRow
              rowName="Date of Birth"
              name="date"
              value={dateOfBirth}
              required="*"
              errMsg={
                dobError ||
                (validationError.dateOfBirth ? validationError.dateOfBirth : "")
              }
              onChange={(val) => {
                this.setState({ error: "" });
                const dob = new Date(val);

                if (!isNaN(dob.getFullYear())) {
                  if (parseInt(dob.getFullYear()) <= 9999) {
                    const diffMs = Date.now() - dob.getTime();
                    const ageDt = new Date(diffMs);
                    const age = Math.abs(ageDt.getUTCFullYear() - 1970);
                    if (age < 15 || age > 80) {
                      this.setState({
                        dobError: "Age must be between 15 and 80 years",
                        dateOfBirth: "",
                      });
                    } else if (isNaN(dob.getFullYear())) {
                    } else {
                      this.setState({ dateOfBirth: val });
                      this.setState({ dobError: "" });
                      this.props.collectState("PI", {
                        fName: fName,
                        mName: mName,
                        lName: lName,
                        dateOfBirth: val,
                        selectedGender: selectedGender,
                      });
                    }
                  }
                } else {
                  this.setState({ dateOfBirth: "" });
                  this.setState({ dobError: "" });
                  this.props.collectState("PI", {
                    fName: fName,
                    mName: mName,
                    lName: lName,
                    dateOfBirth: "",
                    selectedGender: selectedGender,
                  });
                }
              }}
            />
          </div>

          <button
            className="save"
            onClick={() => {
              this.props.onSave();
            }}
          >
            Next
          </button>
        </div>
      </div>
    );
  }
}

PersonalInformation.propTypes = {
  fName: PropTypes.string.isRequired,
  lName: PropTypes.string.isRequired,
  mName: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  gender: PropTypes.string,
  error: PropTypes.object,
  collectState: PropTypes.func,
  dateOfBirth: PropTypes.string,
};
